import { all, fork } from 'redux-saga/effects';

import appEffects from 'state/app/effects';
import authEffects from 'state/auth/effects';
import directOrderEffects from 'state/direct-order/effects';
import directOrderRecurringEffects from 'state/direct-order-recurring/effects';
import mrDistributionEffects from 'state/mrDistribution/effects';
import mrCollectionEffects from 'state/mrCollection/effects';
import shipmentsEffects from 'state/shipments/effects';
import loadsEffects from 'state/loads/effects';
import addressesEffects from 'state/addresses/effects';
import orderEffects from 'state/order/effects';
import ordersEffects from 'state/orders/effects';
import analyticsEffects from 'state/analytics/effects';
import downloadsEffects from 'state/downloads/effects';
import paymentDataEffects from 'state/paymentData/effects';
import editLogEffects from 'state/editLog/effects';
import salesIntelligenceEffects from 'state/salesIntelligence/effects';
import statusEffects from 'state/status/effects';
import uiEffects from 'state/ui/effects';

export default function* rootSaga() {
  yield all([
    fork(authEffects),
    fork(appEffects),
    fork(directOrderEffects),
    fork(directOrderRecurringEffects),
    fork(mrDistributionEffects),
    fork(mrCollectionEffects),
    fork(shipmentsEffects),
    fork(loadsEffects),
    fork(addressesEffects),
    fork(orderEffects),
    fork(ordersEffects),
    fork(analyticsEffects),
    fork(downloadsEffects),
    fork(paymentDataEffects),
    fork(editLogEffects),
    fork(salesIntelligenceEffects),
    fork(statusEffects),
    fork(uiEffects),
  ]);
}

export { editLogEffects };
